import { useEffect } from 'react'
// import './App.css'
import React from 'react'
import AppRoutes from './Routes/AppRoutes.tsx'
import './assets/Style/Mainstyle.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';


// import { setData } from './Redux/GetTimeSlice.tsx';

function App() {


  return (
    <div className='App'>

      <ToastContainer/>
      <AppRoutes />
      {/* <Button className='button-primary'>Hello</Button> */}
      {/* {isLoading && (
        <div className='loader-overlay'>
          <div className='spinner'>
            <div className='clip-loader'></div>
          </div>
        </div> */}
      {/* )} */}
      </div>
  )
}
export default App
